import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-market-place',
  templateUrl: './market-place.component.html',
  styles: [
  ]
})
export class MarketPlaceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
